import { Component} from '@angular/core';

@Component({
    selector: 'registration-main',
    templateUrl: './registration-main.tmpl.html'
})

export class RegistrationMain {
    editMode: boolean = null; 

    public setVal(val:boolean) {
        this.editMode = val;  
    }
}
  